import React, { FC } from 'react'
import { styled } from '@linaria/react'
import { useShareLink } from '../hooks/useShareLink'
import { colors } from '../styles/colors'

export const ShareButton: FC<{
  url: string
  text: string
  className?: string
  disabled?: boolean
  onSuccess?: () => void
  onError?: (error: Error) => void
}> = ({ url, text, className, disabled = false, onSuccess, onError }) => {
  const { shareUrl, isSharing } = useShareLink()

  const handleShareButtonClick = async () => {
    await shareUrl({
      url,
      text,
      onSuccess,
      onError,
    })
  }

  return (
    <StyledButton
      className={className}
      onClick={handleShareButtonClick}
      disabled={disabled || isSharing}
      aria-label="Share link"
    >
      <svg
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="36" height="36" rx="18" fill="white" />
        <path
          d="M27.0002 17.4591L17.4002 11.1001L17.4002 14.7001C9 16.5001 9 24.9001 9 24.9001C9 24.9001 12.6 20.1001 17.4002 20.7001L17.4002 24.4201L27.0002 17.4591Z"
          stroke={colors.grey600}
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </svg>
    </StyledButton>
  )
}

const StyledButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
